import cx from 'classnames';
import { BrandEntity } from 'mk2/apps/strollers/schemas';
import { strollersListUrl } from 'mk2/apps/strollers/urls';
import ImgCropped, { ImgCropMode } from 'mk2/components/ImgCropped';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './BrandsListItem.mscss';

interface OwnProps {
    brand: BrandEntity;
    style?: object;
}

export class BrandsListItem extends React.Component<OwnProps> {

    public render() {
        const { brand, style } = this.props;

        const strollerPhoto = brand.strollerPhoto;

        return (
            <div style={style}>
                <div className={styles.BrandsListItem}>
                    <Link
                        className={styles.BrandsListItem__item}
                        to={url(strollersListUrl, { slug: brand.slug })}
                    >
                        <div className={styles.BrandsListItem__item__image}>
                            {strollerPhoto && (
                                <ImgCropped
                                    width={44}
                                    height={44}
                                    mode={ImgCropMode.Embed}
                                    imgWidth={strollerPhoto.originalWidth}
                                    imgHeight={strollerPhoto.originalHeight}
                                    imgUrl={strollerPhoto.url100x100}
                                    lazy={false}
                                />
                            )}
                        </div>

                        <div className={styles.BrandsListItem__name}>
                            <h2 className={styles.BrandsListItem__name__h2}>{brand.name}</h2>
                        </div>

                        <div className={styles.BrandsListItem__count}>
                            ({brand.numPreparedStrollers})
                        </div>

                        <i className={cx('fa', 'fa-angle-right', styles.BrandsListItem__arrowIcon)} />
                    </Link>
                </div>
            </div>
        );
    }
}

interface PlaceholderOwnProps {
    style?: object;
}

export const BrandsListItemPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ style }) => (
    <div style={style}>
        <div className={styles.BrandsListItem}>
            <span className={styles.BrandsListItem__item}>
                <span className={styles.BrandsListItem__data}>
                    <LoadingPlaceholder width="100%" height={24} />
                </span>
            </span>
        </div>
    </div>
);
BrandsListItemPlaceholder.displayName = 'BrandsListItemPlaceholder';
